<template>
    <div>
      <div v-for="(_, index) in skeletonCount" :key="index" class="skeleton-loader">
        <!-- Skeleton loader card -->
        <div class="result-item">
          <div class="job-info">
            <div class="image_wrapper skeleton"></div>
            <div class="job-detail">
              <div class="job-title skeleton"></div>
              <div class="job-poster skeleton"></div>
              <div class="job-location skeleton"></div>
              <div class="job-category skeleton"></div>
            </div>
            <div class="job-type-label skeleton"></div>
          </div>
          <div class="job-description">
            <p class="skeleton"></p>
            <p class="skeleton"></p>
            <p class="skeleton"></p>
          </div>
          <div class="job-detail-link skeleton"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      skeletonCount: Number // Define the prop to receive the count of skeleton items
    }
  };
  </script>
  
  <style scoped>
  /* Skeleton loader styles */
  .skeleton {
    background: linear-gradient(90deg, rgba(240,240,240,1) 25%, rgba(225,225,225,1) 50%, rgba(240,240,240,1) 75%);
    background-size: 400% 100%;
    animation: shimmer 1.5s infinite linear;
  }
  
  @keyframes shimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
  
  .result-item {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 30px;
  }
  
  .image_wrapper.skeleton {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  
  .job-detail.skeleton {
    display: flex;
    flex-direction: column;
  }
  
  .job-detail.skeleton > div {
    width: 100%;
    height: 20px;
    margin-bottom: 10px;
  }
  
  .job-detail-link.skeleton {
    width: 100px;
    height: 30px;
    border-radius: 5px;
  }

  .skeleton {
    border-radius: 6px;

    .job-detail & + &:not(.job-category) {
        margin-top: 0.4rem;
    }
}
.image_wrapper.skeleton[data-v-abab42e2] {
    max-width: 60px;
    height: 60px;
    border-radius: 6px;

    + .job-detail {
        width: 100%;
    }
}

.job-title.skeleton {
    width: 75%;
    height: 24px;
}

.job-poster.skeleton {
    width: 45%;
    height: 16px;
}

.job-location.skeleton,
.job-category.skeleton {
    width: 45%;
    height: 11px;
}

.job-category.skeleton {
    margin-top: 0.2rem;
}

.job-description .skeleton {
    width: 100%;
    height: 16px;
    margin-bottom: 0.25rem;

    &:last-child {
        width: 60%
    }
}

.job-type-label.skeleton {
    width: 80px;
    border: none;
    height: 26px;
}
  </style>
  